import $ from 'jquery';
import Player from '@vimeo/player';

export default class Video {
    constructor() {
        if ($('.js-video').length) {
            $('.js-video__play-button').on('click', function () {
                const $this = $(this);
                const $parent = $this.closest('.js-video');
                const $videoWrapper = $parent.find('.js-video__video');

                // Local (self-hosted) video: the wrapper IS the <video> element.
                // Click is a user gesture, so play() is allowed to run with sound.
                if ($videoWrapper.is('video')) {
                    $this.fadeOut();
                    $videoWrapper[0].play();
                    // The play button just left the DOM flow; move focus to the
                    // video so keyboard users aren't dropped to <body>.
                    $videoWrapper[0].focus({ preventScroll: true });

                    return;
                }

                const videoSource = $parent.data('source');
                const $video = $videoWrapper.find('iframe');
                let width;
                let height;

                if (videoSource == 'vimeo') {
                    const player = new Player($video[0]);

                    Promise.all([player.getVideoWidth(), player.getVideoHeight()]).then(function (dimensions) {
                        width = dimensions[0];
                        height = dimensions[1];

                        $this.fadeOut();

                        player.play();
                        $video[0].focus({ preventScroll: true });
                    });
                } else {
                    ('use strict');

                    let $videoIframe = $video;
                    const currentSrc = $videoIframe.attr('src');

                    if (currentSrc.indexOf('autoplay=') === -1) {
                        $videoIframe.attr('src', currentSrc + '&autoplay=1');
                    }

                    $this.fadeOut();

                    $videoWrapper.html($videoIframe);
                    $videoIframe[0].focus({ preventScroll: true });
                }
            });
        }
    }
}
